import { USER_CONFIRM_FETCH_REQUEST, USER_CONFIRM_FETCH_SUCCESS, USER_CONFIRM_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    confirm: {},
    error: ''
}

const confirm = (state = initialState, action) => {
    switch (action.type) {
        case USER_CONFIRM_FETCH_REQUEST:
            return {
                loading: true,
                confirm: {},
                error: '',
            }
        case USER_CONFIRM_FETCH_SUCCESS:
            return {
                loading: false,
                confirm: action.payload,
                error: ''
            }
        case USER_CONFIRM_FETCH_FAILURE:
            return {
                loading: false,
                confirm: {},
                error: action.payload
            }
        default:
            return state
    }
}

export default confirm;